import React, { useContext } from 'react'
import { string, func } from 'prop-types'
import classNames from 'classnames'

import styles from './PaywallBarrier.module.scss'
import Type from '../Type'
import FieldTemplate from '../FieldTemplate'
import TextControl from '../TextControl'
import ButtonStandard from '../ButtonStandard'
import Container from '../Container'
import { SignUpContext } from '@/component/Context/SignUpContext'

const PaywallBarrier = ({ className, onSubmit, name }) => {
  const { setEmailAddress, handleModalVisibility } = useContext(SignUpContext)
  const onChange = (e) => {
    if (!e?.target) return
    const { value } = e.target
    setEmailAddress(value)
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    handleModalVisibility(true)
    document.body.classList.add('has-locked-scrolling')
  }

  return (
    <div className={classNames(styles.PaywallBarrier, className)}>
      <div className={styles.Overlay} />
      <div className={styles.Wrapper}>
        <Container
          size="mediumSmall"
          center
          gutter
          className={styles.PaywallBarrierContainer}
        >
          <Type
            themed
            className={styles.Title}
            size={['heading5', 'display2']}
            weight="bold"
          >
            To keep reading subscribe below
          </Type>
          <Type className={styles.Copy} size="body2">
            Subscribe to our newsletter to get the latest information from{' '}
            {name} and join a growing community of experts.
          </Type>
          <form className={styles.Form}>
            <div className={styles.Fields}>
              <FieldTemplate label="Email address" required controlName="email">
                <TextControl
                  name="email"
                  placeholder="Your email"
                  required
                  onChange={onChange}
                  inverse
                  fieldSize="large"
                />
              </FieldTemplate>
            </div>
            <ButtonStandard
              size="huge"
              className={styles.Submit}
              onClick={handleSubmit}
              primary
            >
              <Type size={['body2', 'body4']} weight="medium">
                Subscribe now
              </Type>
            </ButtonStandard>
          </form>
        </Container>
      </div>
    </div>
  )
}

PaywallBarrier.propTypes = {
  className: string,
  onSubmit: func,
  name: string
}

export default PaywallBarrier
